import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { WA_LINK } from "../site";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const WhatsAppFloat = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.5);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp-button"
          aria-label="Book via WhatsApp"
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 right-6 z-50 group flex items-center gap-3 rounded-full bg-[#128C4A] hover:bg-[#16a35a] pl-4 pr-5 py-4 text-white shadow-[0_0_24px_rgba(37,211,102,0.4)] transition-colors duration-300"
        >
          <span className="absolute inset-0 rounded-full bg-wa/40 animate-pulse-ring" />
          <WhatsAppIcon className="relative w-6 h-6" />
          <span className="relative hidden sm:inline text-sm font-semibold tracking-wide">Book Now</span>
        </motion.a>
      )}
    </AnimatePresence>
  );
};
